/// <amd-module name="WidgetCommon/WitUtils/TemporaryDataClient/RestClient/TemporaryData" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\dashboards\widgetcommon\widget-wit-utils\temporarydataclient\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as TemporaryData from "../Contracts/TemporaryData";

import { ITemporaryDataRestClient } from "WidgetCommon/WitUtils/TemporaryDataClient/RestClient/TemporaryData.Types";

export { ITemporaryDataRestClient } from "WidgetCommon/WitUtils/TemporaryDataClient/RestClient/TemporaryData.Types";

class TemporaryDataRestClient extends RestClientBase implements ITemporaryDataRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Create a new temporary data with the provided guid
     * 
     * @param requestBody - The data of temporary artifact in json format.
     * @param id - New temporary data Id
     */
    public async createTemporaryData(
        requestBody: TemporaryData.TemporaryDataDTO,
        id?: string
        ): Promise<TemporaryData.TemporaryDataCreatedDTO> {

        return this.beginRequest<TemporaryData.TemporaryDataCreatedDTO>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "_apis/properties/{id}",
            routeValues: {
                id: id
            },
            body: requestBody
        });
    }

    /**
     * Get a temporary artifact.
     * 
     * @param id - The ID of the temporary artifact.
     */
    public async getTemporaryData(
        id: string
        ): Promise<TemporaryData.TemporaryDataCreatedDTO> {

        return this.beginRequest<TemporaryData.TemporaryDataCreatedDTO>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/properties/{id}",
            routeValues: {
                id: id
            }
        });
    }

}

export const TemporaryDataClientName = "VelocityWidget-TemporaryData.ITemporaryDataRestClient";

export function getTemporaryDataClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITemporaryDataRestClient {
    return pageContext.getRestClient<ITemporaryDataRestClient>(TemporaryDataClientName, options);
}

RestClients.add(TemporaryDataClientName, { 
    factory: TemporaryDataRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
